import React from 'react'
import { Button, Col, Modal } from 'react-bootstrap'

export interface ModalAyudaProps {
    showModalAyuda: boolean
    handleCloseModalAyuda: () => void
}

const pdfManual = "/ManualGuiaDePedidoV3.pdf"

const ModalAyuda = ({
    showModalAyuda,
    handleCloseModalAyuda,
}: ModalAyudaProps) => {

    const abrirEnNuevaVentana = () => {
        if (pdfManual) {
            window.open(pdfManual, '_blank')
        }
    }

    return (

        <>
            <Modal
                animation={false}
                backdrop="static"
                show={showModalAyuda}
                onHide={handleCloseModalAyuda}
                centered
                size="xl"
            >
                <Modal.Header>
                    <Modal.Title style={{ color: 'white' }}>Vista previa PDF</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Col className="d-flex flex-column align-items-center">

                        <object
                            data={pdfManual}
                            type="application/pdf"
                            width="100%"
                            height="600px"
                            aria-label="Vista previa PDF"
                            style={{ border: '1px solid #ccc', marginTop: 15 }}
                        />

                        <div className="mt-3">
                            <div className="row g-2">

                                <>
                                    <div className="col-12 col-md-auto">
                                        <Button
                                            className="w-100"
                                            variant="primary"
                                            onClick={abrirEnNuevaVentana}
                                        >
                                            Abrir en nueva ventana
                                        </Button>
                                    </div>

                                    <div className="col-12 col-md-auto">
                                        <Button
                                            className="w-100"
                                            variant="success"
                                        >
                                            <a style={{textDecoration: 'none', color: 'white'}} href={pdfManual} download>
                                                Descargar manual
                                            </a>
                                        </Button>
                                    </div>


                                </>

                                <div className="col-12 col-md-auto">
                                    <Button
                                        className="w-100"
                                        variant="danger"
                                        onClick={handleCloseModalAyuda}
                                    >
                                        Cerrar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default ModalAyuda
